module.exports = __webpack_public_path__ + "img/listing-es.3eab8133.png";